export default __webpack_public_path__ + "static/media/crowd-fund1.c5f57088.jpg";